"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setSpacingFactor", {
  enumerable: true,
  get: function get() {
    return _calculateSpacing.setSpacingFactor;
  }
});
Object.defineProperty(exports, "getSpacingFactor", {
  enumerable: true,
  get: function get() {
    return _calculateSpacing.getSpacingFactor;
  }
});
Object.defineProperty(exports, "setSpacingScale", {
  enumerable: true,
  get: function get() {
    return _calculateSpacing.setSpacingScale;
  }
});
Object.defineProperty(exports, "getSpacingScale", {
  enumerable: true,
  get: function get() {
    return _calculateSpacing.getSpacingScale;
  }
});
Object.defineProperty(exports, "calculateSpacing", {
  enumerable: true,
  get: function get() {
    return _calculateSpacing.calculateSpacing;
  }
});
Object.defineProperty(exports, "vdsSpacingScale", {
  enumerable: true,
  get: function get() {
    return _spacingScale.vdsSpacingScale;
  }
});

var _calculateSpacing = require("./calculateSpacing");

var _spacingScale = require("./spacingScale");


//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/theme/dist/cjs/layout/spacing/index.js
// module id = 1299
// module chunks = 0